import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/trhGqHnSffkjGnxXhUwbwQ/mindfulness_(3).png',
  label: 'Mindfulness · Respiración para bajar revoluciones'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cjJ4yuMqGpHRxE1K8hzRhg/mindfulness_(4).png',
  label: 'Mindfulness · Antes de responder en caliente'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cBZqGtpWSKTU9JRFB8RzCN/mindfulness_(20).png',
  label: 'Mindfulness · Tu pausa de emergencia cuando estás saturado'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1XRzweKUvZNRKZhDWKZtG1/KIT_CONVERSACIONES_DIFICILES_(4).png',
  label: 'Conversaciones Difíciles · Cuando te hablan mal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2Adpo4BLdEXKLmfoabzafx/KIT_CONVERSACIONES_DIFICILES_(14).png',
  label: 'Conversaciones Difíciles · Cómo salir de una conversación de chismes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/naMuQ8719Pdq3Lauu8FbT2/100_RESPUESTAS_(1).png',
  label: '100 Respuestas · Frases concretas para situaciones difíciles'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/m4AaM4MtECk1WFSHQbDys6/EJERCISIOS_MEJORAR_(2).png',
  label: 'Ambiente Laboral · Lo que ayuda y lo que desgasta'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6VL9E4xScLbwAKEynrMZMa/EJERCISIOS_MEJORAR_(4).png',
  label: 'Ambiente Laboral · Acuerdos que evitan conflictos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2JrJNitSbmi9dh4AH15Mtr/EJERCISIOS_MEJORAR_(10).png',
  label: 'Ambiente Laboral · Nuestro acuerdo de trabajo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bqm1bmz8ryLrgjJciRpDJ9/material_premium_Neurociencia_(1).png',
  label: 'Premium · Neurociencia: experimentos para entender cómo responde tu cerebro'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3cA1Cs6ea4a8k2i4arBkPE/material_premium_Neurociencia_(2).png',
  label: 'Premium · Neurociencia: tu estrés también ocurre en el cuerpo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pD45TRw9inZiLR3zvr16bs/material_premium_umbral_del_descanso_(2).png',
  label: 'Premium · El Umbral del Descanso: cuando el trabajo termina y tu cabeza sigue'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jJqML7XPUk6xPXXPmJDbrQ/material_premium_umbral_del_descanso_(3).png',
  label: 'Premium · El Umbral del Descanso: qué ocurre mientras empezamos a dormir'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7sjYx9Fr5hGqoRAtvGb92w/material_premium_umbral_del_descanso_(9).png',
  label: 'Premium · El Umbral del Descanso: ¿estoy resolviendo o solamente pensando?'
}];
export function PreviewSection() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0);
  const go = (d: number) => {
    setDir(d);
    setIndex(p => (p + d + slides.length) % slides.length);
  };
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-262" data-mp="20biggpcfi3jg">
      <div className="max-w-5xl mx-auto" data-id="element-263" data-mp="1w7kkuombbav5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-264" data-mp="1w9x8nier4fg4">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-265" data-mp="1cjk2typibw35">
            👀 Mirá el kit{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-266" data-mp="18k2vt0ufmqvv">
              por dentro
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-3" data-id="element-267" data-mp="32wixrpg73iux">
            Páginas reales del material que vas a recibir
          </p>
        </motion.div>

        <div className="relative max-w-2xl mx-auto" data-id="element-268" data-mp="1umih24qhp8qo">
          <div className="relative bg-white border border-line rounded-3xl p-3 md:p-5 shadow-xl" data-id="element-269" data-mp="1ums87vn9tlxy">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-bg-warm" data-id="element-270" data-mp="1zkttmn865xcl">
              <AnimatePresence initial={false} mode="wait" data-id="element-271" data-mp="1lkstj9zqaty6">
                <motion.img key={index} src={slides[index].src} alt={slides[index].label} initial={{
                opacity: 0,
                x: dir > 0 ? 50 : -50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: dir > 0 ? -50 : 50
              }} transition={{
                duration: 0.4
              }} className="absolute inset-0 w-full h-full object-contain" data-id="element-272" data-mp="1qk5oki0r77bu" />
              </AnimatePresence>
            </div>
          </div>

          <button onClick={() => go(-1)} aria-label="Anterior" className="absolute left-1 md:-left-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-273" data-mp="eaq1rncq49e0">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-274" data-mp="x8smhpy8nk60" />
          </button>
          <button onClick={() => go(1)} aria-label="Siguiente" className="absolute right-1 md:-right-5 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-line shadow-lg flex items-center justify-center hover:bg-rose hover:text-white text-ink transition-colors" data-id="element-275" data-mp="x6zfg9jpqxxh">
            <ChevronRightIcon className="w-5 h-5" data-id="element-276" data-mp="1fz1w3kwcue7q" />
          </button>
        </div>

        <div className="flex flex-col items-center gap-4 mt-6" data-id="element-277" data-mp="1by8d95xrrplp">
          <div className="text-sm text-muted font-medium text-center px-4 font-serif-italic" data-id="element-278" data-mp="1bvvjzwmk9stc">
            {slides[index].label}
          </div>
          <div className="flex gap-2" data-id="element-279" data-mp="1nzq5i5f84gca">
            {slides.map((_, i) => <button key={i} aria-label={`Material ${i + 1}`} onClick={() => {
            setDir(i > index ? 1 : -1);
            setIndex(i);
          }} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-8 bg-rose' : 'w-1.5 bg-rose/25'}`} data-id="element-280" data-mp="1szcj4fyyrylm" data-mpi={i} />)}
          </div>
        </div>

        <p className="text-center font-serif-italic text-rose mt-8 text-lg" data-id="element-281" data-mp="2bpu6s64xw404">
          La mirada práctica del Método Aula Mater
        </p>
      </div>
    </section>;
}